import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY } from 'rxjs';
import { TokenStorageService } from '@core/services/token-storage.service';
import { AuthService } from '@core/services/auth.service';

const LOGIN_URL = '/api/auth/login';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // El endpoint de login nunca lleva Bearer
  if (req.url.includes(LOGIN_URL)) return next(req);

  const tokenStorage = inject(TokenStorageService);
  const auth = inject(AuthService);
  const token = tokenStorage.getToken();

  if (!token) return next(req);

  // Si el token ha caducado: logout limpio, no enviamos la request
  if (tokenStorage.isExpired()) {
    auth.logout();
    return EMPTY;
  }

  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));

  // Punto de extensión Fase 1: refresh token antes de reintentar
};
